import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { DEPARTMENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/structure/departments/")({
  component: () => <DeptContentList cfg={DEPARTMENTS} />,
});
